import React from 'react';
import { useTranslation } from 'react-i18next';

export default function University() {
  const { t } = useTranslation();
  return (
    <div className="university-wrapper">
      <div className="label">{t('cms.dashboard.strategy.module_setting.university')}</div>
      <div className="right-wrapper">
        {t('cms.dashboard.strategy.homepage_setting.university.tips')}
      </div>
    </div>
  );
}
